import { useState } from 'react';

import { exportFilename, serializeLogEntries } from '../core/logEntry.js';
import { useLogs } from '../state/LogsProvider.js';

export function LogActions() {
  const { entries, clear } = useLogs();
  const [copied, setCopied] = useState(false);

  const json = serializeLogEntries(entries);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(json);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard write can be denied; user can fall back to Download */
    }
  };

  const onDownload = () => {
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = exportFilename(Date.now());
    a.click();
    URL.revokeObjectURL(url);
  };

  const onClear = () => {
    if (entries.length === 0) return;
    const confirmed = window.confirm(
      `Clear all ${entries.length} log entries? This cannot be undone.`,
    );
    if (confirmed) clear();
  };

  return (
    <section className="section">
      <h2>Session Log ({entries.length} {entries.length === 1 ? 'entry' : 'entries'})</h2>
      <div className="row">
        <button type="button" onClick={onCopy} disabled={entries.length === 0}>
          {copied ? 'Copied!' : 'Copy as JSON'}
        </button>
        <button type="button" onClick={onDownload} disabled={entries.length === 0}>
          Download .json
        </button>
        <button type="button" onClick={onClear} disabled={entries.length === 0}>
          Clear
        </button>
      </div>
    </section>
  );
}
